/**
 * Created by Alex Xia on 4/21/2023
 * Description:
 *
 * ---------maintenance history-------------
 */

import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CalendarViewLayoutMenuConfig } from './calendar-view-layout.model';
import { Subscription } from 'rxjs';
import { ContextMenuConfig, ContextMenuShowAction } from '../../../widgets/tam-context-menu/tam-context-menu.model';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'calendar-view-layout',
    templateUrl: './calendar-view-layout.component.html',
    styleUrls: ['./calendar-view-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarViewLayoutComponent implements OnInit, OnDestroy {
    @Input() config: CalendarViewLayoutMenuConfig;

    public iconName = 'calendar';
    public calendarLayoutContextMenuConfig: ContextMenuConfig;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(private _changeDetectorRef: ChangeDetectorRef) { }

    ngOnInit() {
        this._initContextMenu();
        this._changeLayoutMenuInfo(this.config);

        this._destroySubscriptions.push(
            this.config.actions$.subscribe(action => this._onSubscribeActions(action))
        );
        this._changeDetectorRef.detectChanges();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    onLayoutMenuSelect(event) {
        let changeStatus = true;
        const layoutItems = this.calendarLayoutContextMenuConfig.items;

        for (let i = 0; i < layoutItems.length; i++) {
            if (event.payload.id < 3) {
                if (layoutItems[i].checked && layoutItems[i].id === event.payload.id) {
                    changeStatus = false;
                    break;
                }
            }
        }

        if (changeStatus) {
            if (event.payload.id < 3) {
                this.calendarLayoutContextMenuConfig.items[0].checked = false;
                this.calendarLayoutContextMenuConfig.items[1].checked = false;
                this.calendarLayoutContextMenuConfig.items[event.payload.id - 1].checked = true;
                this.iconName = this.calendarLayoutContextMenuConfig.items[event.payload.id - 1].icon;
            }
            if (event.payload.id === 1) {
                this.iconName = 'calendar';
            } else {
                this.iconName = 'chart-grid';
            }
            if (this.config && this.config.events$) {
                this.config.events$.next({
                    type: 'CHANGE',
                    payload: event.payload
                });
            }
            this._changeDetectorRef.detectChanges();
        }
    }

    showCalendarLayoutContextMenu(e: MouseEvent) {
        this.calendarLayoutContextMenuConfig.show$.next(new ContextMenuShowAction(e, ''));
    }

    private _changeLayoutMenuInfo(action?) {
        if (action) {
            this.config = action;
        }
        if (this.config) {
            if (this.config.layoutInfo.layoutMode) {
                this.calendarLayoutContextMenuConfig.items[0].checked = false;
                this.calendarLayoutContextMenuConfig.items[1].checked = false;
                this.calendarLayoutContextMenuConfig.items.forEach(item => {
                    if (item.id === this.config.layoutInfo.layoutMode) {
                        item.checked = true;
                        this.iconName = this.calendarLayoutContextMenuConfig.items[item.id - 1].icon;
                    }
                });
            }
        }
        this._changeDetectorRef.detectChanges();
    }

    private _initContextMenu() {
        this.calendarLayoutContextMenuConfig = new ContextMenuConfig();
        this.calendarLayoutContextMenuConfig.single = true;
        this.calendarLayoutContextMenuConfig.showItemIcon = true;
        this.calendarLayoutContextMenuConfig.items = [
            { id: 1, text: 'Calendar View', icon: 'calendar', checked: true },
            { id: 2, text: 'Grid View', icon: 'chart-grid' },
        ];
        this.calendarLayoutContextMenuConfig.events$.subscribe(event => this.onLayoutMenuSelect(event));
    }

    private _onSubscribeActions(action) {
        this._changeLayoutMenuInfo(action);
    }
}
